/* eslint-disable prettier/prettier */
export default {
  // 共通
	//  ＴＯＰ／ヘッダ
	'ホーム': 'ホーム',
	'サイドメニューより操作項目を選択してください': 'サイドメニューより操作項目を選択してください',
	'ログアウト': 'ログアウト',
	'公開店舗/学校/病院数': '公開数',
	'非公開店舗/学校/病院数': '非公開数',
	'センサー総数': 'センサー総数',
	'表示言語': '言語/langage',
	'加入店舗数取得時にエラーが発生しました': '加入店舗数取得時にエラーが発生しました',
	'選択中のリセラー情報': '選択中のリセラー情報',
	//  メニュー
	'リセラー情報管理': 'リセラー情報管理',
	'グループ情報管理': 'グループ情報管理',
	'店舗/学校/病院情報管理': '店舗/学校/病院情報管理',
	'店舗/学校/病院確認一覧': '店舗/学校/病院確認一覧',
	'センサー管理': 'センサー管理',
	'センサーデータダウンロード': 'センサーデータダウンロード',
	'セキュリティ情報管理': 'セキュリティ情報管理',
	'グラフ埋め込み用HTML出力': 'グラフ埋め込み用HTML出力',
	'ユーザー情報管理': 'ユーザー情報管理',
	'マニュアル/FAQ': 'マニュアル/FAQ',
	'利用規約': '利用規約',
	'メニューの取得に失敗しました': 'メニューの取得に失敗しました',
	'再読み込み': '再読み込み',
	//  グループ情報管理.一覧
	'新規登録': '新規登録',
	'編集': '編集',
	'削除': '削除',
	'グループID': 'グループID',
	'グループ名': 'グループ名',
	'グループ管理者の会社名': 'グループ管理者の会社名',
	'{groupName}を削除します。よろしいですか？': '{groupName}を削除します。よろしいですか？',
	'グループ情報が削除されました。': 'グループ情報が削除されました。',
	'本機能を利用する権限がありません': '本機能を利用する権限がありません',
	'施設情報取得時にエラーが発生しました': '施設情報取得時にエラーが発生しました',
	//  グループ情報管理.詳細
	'グループ情報の登録': 'グループ情報の登録',
	'グループ情報の更新': 'グループ情報の更新',
	
	
	'必須項目です。140文字以内で入力してください。': '必須項目です。140文字以内で入力してください。',
	'グループ名（英語表記）': 'グループ名（英語表記）',
	'必須項目です。半角文字140文字以内で入力してください。': '必須項目です。半角文字140文字以内で入力してください。',
	'グループ管理者のメールアドレス': 'グループ管理者のメールアドレス',
	'必須項目です。EMAILアドレスの書式で、256文字以内で入力してください。': '必須項目です。EMAILアドレスの書式で、256文字以内で入力してください。',
	
	
	'グループ管理者の会社名（英語表記）': 'グループ管理者の会社名（英語表記）',
	
	'グループ管理者のWEBサイトURL': 'グループ管理者のWEBサイトURL',
	'必須項目です。512文字以内で入力してください。': '必須項目です。512文字以内で入力してください。',
	'副管理者一覧': '副管理者一覧',
	'副管理者追加': '副管理者追加',
	'グループ副管理者のメールアドレス': 'グループ副管理者のメールアドレス',
	'グループ共通情報': 'グループ共通情報',
	'以下の公開情報についてサブグループごとに実施有無を入力してください。(実施有無の入力は画面下部のサブグループ一覧にて実施)': '以下の公開情報についてサブグループごとに実施有無を入力してください。(実施有無の入力は画面下部のサブグループ一覧にて実施)',
	'公開情報': '公開情報',
	'内容': '内容',
	'回答番号': '回答番号',
	'換気': '換気',
	'建築基準法の必要換気量を確保しています。（一人当たり30m/時もしくは、床と窓の面積比が５:1程度）': '建築基準法の必要換気量を確保しています。（一人当たり30m/時もしくは、床と窓の面積比が５:1程度）',
	'換気①': '換気①',
	'換気設備の運転状況を確認しています。（または定期的な窓の開放を実施しています）': '換気設備の運転状況を確認しています。（または定期的な窓の開放を実施しています）',
	'換気②': '換気②',
	'トイレ消毒': 'トイレ消毒',
	'トイレ定期清掃・消毒、ドアノブの消毒、消毒液設置をしています': 'トイレ定期清掃・消毒、ドアノブの消毒、消毒液設置をしています',
	'トイレ①': 'トイレ①',
	'サブグループ一覧': 'サブグループ一覧',
	'サブグループ追加': 'サブグループ追加',
	'サブグループID': 'サブグループID',
	'店舗/学校/病院情報表示': '店舗/学校/病院情報表示',
	'表示': '表示',
	'サブグループ名': 'サブグループ名',
	'店舗/学校/病院情報管理者のメールアドレス': '店舗/学校/病院情報管理者のメールアドレス',
	
	
	
	
	'戻る': '戻る',
	'登録': '登録',
	'グループ情報が登録されました。店舗/学校/病院情報を登録すると公開されます。': 'グループ情報が登録されました。店舗/学校/病院情報を登録すると公開されます。',
	'グループ情報が更新されました。': 'グループ情報が更新されました。',
	
	'指定されたグループが管理対象でないため表示できません。': '指定されたグループが管理対象でないため表示できません。',
	'施設情報詳細取得時にエラーが発生しました': '施設情報詳細取得時にエラーが発生しました',
	'サブグループ名なし（{xx}行目）を削除します。よろしいですか？': 'サブグループ名なし（{rowno}行目）を削除します。よろしいですか？',
	'{サブグループ名}を削除します。よろしいですか？': '{subgroupname}を削除します。よろしいですか？',
	'店舗情報削除時にエラーが発生しました': '店舗情報削除時にエラーが発生しました',
	'副管理者（{xx}行目）を削除します。よろしいですか？': '副管理者（{rowno}行目）を削除します。よろしいですか？',
	'{managerEmail}を削除します。よろしいですか？': '{managerEmail}を削除します。よろしいですか？',
	'施設の管理者アドレスがユーザ情報に登録されていません。システム管理者にご連絡ください。': '施設の管理者アドレスがユーザ情報に登録されていません。システム管理者にご連絡ください。',
	'施設の管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。': '施設の管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。',
	'店舗の管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。': '店舗の管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。',
	'データ登録時にエラーが発生しました。': 'データ登録時にエラーが発生しました。',

	'アラート・レポート管理時間': 'アラート・レポート管理時間',	
	'設定する': '設定する',	
	'設定しない': '設定しない',	
	'開始': '開始時間',	
	'終了': '終了時間',	
	'sunday': '日曜日',	
	'monday': '月曜日',	
	'tuesday': '火曜日',	
	'wednesday': '水曜日',	
	'thursday': '木曜日',	
	'friday': '金曜日',	
	'saturday': '土曜日',	
	'のアラート・レポート管理時間（{xx}行目）を削除します。よろしいですか？': 'のアラート・レポート管理時間（{rowno}行目）を削除します。よろしいですか？',
	'除外': '除外',	
	'除外日の追加': '除外日の追加',	
	'除外日': '除外日',	
	'除外日（{xx}行目）を削除します。よろしいですか？': '除外日（{rowno}行目）を削除します。よろしいですか？',
	'{exclusionDate}を削除します。よろしいですか？': '{exclusionDate}を削除します。よろしいですか？',
	'未入力の項目を埋めてください。': '未入力の項目を埋めてください。',	
	'終了時間は、開始時間より後の時間を入力してください。': '終了時間は、開始時間より後の時間を入力してください。',	
	'同一曜日内の開始時間・終了時間は重複しないようにしてください。': '同一曜日内の開始時間・終了時間は重複しないようにしてください。',	
	'終了時間は24:00までを入力してください。': '終了時間は24:00までを入力してください。',	
	'（{row1}行目）と（{row2}行目）の除外日が重複しています。': '（{row1}行目）と（{row2}行目）の除外日が重複しています。',
	
	
	'データ更新時にエラーが発生しました。': 'データ更新時にエラーが発生しました。',
	
	'施設情報削除時にエラーが発生しました': '施設情報削除時にエラーが発生しました',
	'レポート発行設定': 'レポート発行設定',
	'グループ管理者/副管理者に登録されているユーザに「グループレポート」のメールを発行します。': 'グループ管理者/副管理者に登録されているユーザに「グループレポート」のメールを発行します。',
	'発行する': '発行する',
	'発行しない': '発行しない',
	'グループレポートダウンロード': 'グループレポートダウンロード',
	'年/月を指定して、過去の「グループレポート」をダウンロードします。': '年/月を指定して、過去の「グループレポート」をダウンロードします。',
	'店舗レポート一括ダウンロード': '店舗レポート一括ダウンロード',
	'年/月を指定して、グループ内の「店舗レポート」を一括ダウンロードします。': '年/月を指定して、グループ内の「店舗レポート」を一括ダウンロードします。',
	'登録される副管理者から利用規約(T*Platsに関する個人情報の取扱い)について同意を確認しました。': '登録される副管理者から利用規約(T*Platsに関する個人情報の取扱い)について同意を確認しました。',
	//  店舗/学校/病院情報管理.一覧
	
	
	
	
	
	
	
	'条件クリア': '条件クリア',
	
	
	
	'お知らせ設定': 'お知らせ設定',
	'店舗/学校/病院名': '店舗/学校/病院名',
	
	'お知らせ管理': 'お知らせ管理',
	
	
	
	
	'アンケート結果': 'アンケート結果',
	'取得': '取得',
	
	'店舗情報取得時にエラーが発生しました': '店舗情報取得時にエラーが発生しました',
	//  店舗/学校/病院情報管理.詳細
	'店舗/学校/病院情報の更新': '店舗/学校/病院情報の更新',
	'公開設定': '公開設定',
	'公開する ': '公開する ',
	'非公開にする': '非公開にする',
	'非公開時URL': '非公開時URL',
	'英語版HPあり': '英語版HPあり',
	'英語版HPなし': '英語版HPなし',
	'表示ポータル設定': '表示ポータル設定',
	'おみせのトラスト': '店舗向け',
	'教室のトラスト': '教室向け',
	'病室のトラスト': '病室向け',
	
	
	
	
	
	'店舗/学校/病院情報管理者の会社名': '店舗/学校/病院情報管理者の会社名',
	
	'店舗/学校/病院情報管理者の会社名（英語表記）': '店舗/学校/病院情報管理者の会社名（英語表記）',
	'半角文字140文字以内で入力してください。': '半角文字140文字以内で入力してください。',
	
	
	'店舗/学校/病院名（英語表記）': '店舗/学校/病院名（英語表記）',
	
	'住所': '住所',
	
	'住所（英語表記）': '住所（英語表記）',
	'GoogleMapプレビュー':'GoogleMapプレビュー',
	'GoogleMap preview':'GoogleMap preview',
	'店舗/学校/病院URL（メイン）': '店舗/学校/病院URL（メイン）',
	'連携URL1': '連携URL1',
	'店舗/学校/病院URL（その他1）': '店舗/学校/病院URL（その他1）',
	'連携URL2': '連携URL2',
	'店舗/学校/病院URL（その他2）': '店舗/学校/病院URL（その他2）',
	'連携URL3': '連携URL3',
	'店舗/学校/病院URL（その他3）': '店舗/学校/病院URL（その他3）',
	'連携URL4': '連携URL4',
	'独自ページ': '独自ページ',
	'食べログ': '食べログ',
	'ホットペッパー': 'ホットペッパー',
	'ぐるなび': 'ぐるなび',
	'コメント（140字以内）': 'コメント（140字以内）',
	'140文字以内で入力してください。': '140文字以内で入力してください。',
	'コメント（140字以内）（英語表記）': 'コメント（140字以内）（英語表記）',
	'半角140文字以内で入力してください。': '半角140文字以内で入力してください。',
	
	'管理者追加': '管理者追加',
	'店舗/学校/病院情報副管理者のメールアドレス': '店舗/学校/病院情報副管理者のメールアドレス',
	
	'アラート通知設定': 'アラート通知設定',
	'通知方法': '通知方法',
	
	'実施': '実施',
	'半角256文字以内で入力してください。': '半角256文字以内で入力してください。',
	'通知しない': '通知しない',
	'通知する': '通知する',
	'メール': 'メール',
	'管理者と副管理者に登録されているユーザにアラートメールを送信します。': '管理者と副管理者に登録されているユーザにアラートメールを送信します。',
	
	
	'SMS': 'SMS',
	'SMSを用いてアラート通知を行います。': 'SMSを用いてアラート通知を行います。',
	'SMS通知機能は、試用版です。今後、有償オプション化を検討しています。': 'SMS通知機能は、試用版です。今後、有償オプション化を検討しています。',
	'連絡先追加': '連絡先追加',
	'アラート通知先電話番号(ハイフンなし)': 'アラート通知先電話番号(ハイフンなし)',
	
	
	
	'センサー管理画面へ': 'センサー管理画面へ',
	'編集中データは、保存されません。センサー管理画面へ移動しますか？':'編集中データは、保存されません。センサー管理画面へ移動しますか？',
	'保存する場合は、移動前に画面にて更新ボタンをクリックしてください。':'保存する場合は、移動前に画面にて更新ボタンをクリックしてください。',
	'画像情報': '画像情報',
	'アップロードする画像の種類に該当するアイコンを選んでください。': 'アップロードする画像の種類に該当するアイコンを選んでください。',
	'店舗/学校/病院': '店舗/学校/病院',
	
	'店舗/学校/病院消毒': '店舗/学校/病院消毒',
	'お客様の安全': 'お客様の安全',
	'テーブル間距離/間仕切り': 'テーブル間距離/間仕切り',
	'従業員の安全衛生管理': '従業員の安全衛生管理',
	
	'認証の取得': '認証の取得',
	'ファイル指定': 'ファイル指定',
	'ファイルを指定してください': 'ファイルを指定してください',
	'アップロードできないファイルが指定されています。': 'アップロードできないファイルが指定されています。',
	'ファイルが指定されていません。': 'ファイルが指定されていません。',
	'画像区分が選択されていません。': '画像区分が選択されていません。',
	'画像区分「店舗/学校/病院」の画像は1つしか登録できません。': '画像区分「店舗/学校/病院」の画像は1つしか登録できません。',
	'画像アップロードに失敗しました。ファイルが破損している可能性があります。ファイルをご確認の上、再度アップロードを実施してください。': '画像アップロードに失敗しました。ファイルが破損している可能性があります。ファイルをご確認の上、再度アップロードを実施してください。',
	'※画像アップロード後、更新ボタンを押すことで画像が表示されるようになります。': '※画像アップロード後、更新ボタンを押すことで画像が表示されるようになります。',
	'※10MB以下の、JPG形式、PNG形式ファイルに対応しています。': '※10MB以下の、JPG形式、PNG形式ファイルに対応しています。',
	'画像区分': '画像区分',
	'サムネイル': 'サムネイル',
	'状態': '状態',
	'公開': '公開',
	'非公開（アップロード済み）': '非公開（アップロード済み）',
	'アップロード': 'アップロード',
	'※画像は3:2で表示されます。縦横比が異なるものは中央部分が表示されます。': '※画像は3:2で表示されます。縦横比が異なるものは中央部分が表示されます。',
	'動画情報': '動画情報',
	'動画リンク埋め込み': '動画リンク埋め込み',
	'512文字以内の半角文字列を入力してください。': '512文字以内の半角文字列を入力してください。',
	'※YoutubeのURL [https://www.youtube.com/watch?v=〇〇〇] もしくは、動画ID（〇〇〇の部分のみ）を入力してください。': '※YoutubeのURL [https://www.youtube.com/watch?v=〇〇〇] もしくは、動画ID（〇〇〇の部分のみ）を入力してください。',
	'※スペース、および＆は入力できません。': '※スペース、および＆は入力できません。',
	'店舗/学校/病院信頼性情報': '店舗/学校/病院信頼性情報',
	
	
	
	
	'換気設備の運転状況を確認、または定期的な窓の開放を実施': '換気設備の運転状況を確認、または定期的な窓の開放を実施',
	'おみせのトラスト：お客様の安全': '店舗向け：お客様の安全',
	'病室のトラスト：患者様の安全': '病室向け：患者様の安全',
	'教室のトラスト：学校関係者の安全': '教室向け：生徒、学生などの安全',
	'おみせのトラスト：入口における消毒液を設置、入店時お客様にて消毒実施': '店舗向け：入口における消毒液を設置、入店時お客様にて消毒実施',
	'病室のトラスト：入口における消毒液を設置、来院時患者様にて消毒実施': '病室向け：入口における消毒液を設置、来院時患者様にて消毒実施',
	'教室のトラスト：入口における消毒液を設置、登校時学校関係者にて消毒実施': '教室向け：入口における消毒液を設置、入退出時生徒、学生などにて消毒実施',
	'おみせのトラスト：入店時お客様に検温を実施': '店舗向け：入店時お客様に検温を実施',
	'病室のトラスト：来院時患者様に検温を実施': '病室向け：来院時患者様に検温を実施',
	'教室のトラスト：登校時学校関係者に検温を実施': '教室向け：生徒、学生などに検温を実施',
	'グループ同士で１ｍの間隔が空けられているもしくはパーティションで区切られている': 'グループ同士で１ｍの間隔が空けられているもしくはパーティションで区切られている',
	'おみせのトラスト：テーブル間距離': '店舗向け：テーブル間距離',
	'病室のトラスト：テーブル間距離': '病室向け：テーブル間距離',
	'教室のトラスト：机間距離': '教室向け：机間距離',
	'おみせのトラスト：グループ同士で１ｍの間隔が空けられているもしくはパーティションで区切られている': '店舗向け：グループ同士で１ｍの間隔が空けられているもしくはパーティションで区切られている',
	'病室のトラスト：グループ同士で１ｍの間隔が空けられているもしくはパーティションで区切られている': '病室向け：グループ同士で１ｍの間隔が空けられているもしくはパーティションで区切られている',
	'教室のトラスト：隣同士で１ｍの間隔が空けられているもしくはパーティションで区切られている': '教室向け：隣同士で１ｍの間隔が空けられているもしくはパーティションで区切られている',
	'おみせのトラスト：従業員の安全衛生管理': '店舗向け：従業員の安全衛生管理',
	'病室のトラスト：病院関係者の安全衛生管理': '病室向け：病院関係者の安全衛生管理',
	'教室のトラスト：学校関係者の安全衛生管理': '教室向け：教職員などの安全衛生管理',
	'おみせのトラスト：従業員の検温、体調管理を実施': '店舗向け：従業員の検温、体調管理を実施',
	'病室のトラスト：病院関係者の検温、体調管理を実施': '病室向け：病院関係者の検温、体調管理を実施',
	'教室のトラスト：学校関係者の検温、体調管理を実施': '教室向け：教職員などの検温、体調管理を実施',
	'おみせのトラスト：従業員のマスクまたはフェイスガードの着用': '店舗向け：従業員のマスクまたはフェイスガードの着用',
	'病室のトラスト：病院関係者のマスクまたはフェイスガードの着用': '病室向け：病院関係者のマスクまたはフェイスガードの着用',
	'教室のトラスト：学校関係者のマスクまたはフェイスガードの着用': '教室向け：教職員などのマスクまたはフェイスガードの着用',
	'おみせのトラスト：店舗消毒': '店舗向け：店舗消毒',
	'病室のトラスト：室内消毒': '病室向け：室内消毒',
	'教室のトラスト：室内消毒': '教室向け：室内消毒',
	'おみせのトラスト：ドアノブ、券売機、セルフドリンクコーナーなどのお客様フロアにある設備の消毒': '店舗向け：ドアノブ、券売機、セルフドリンクコーナーなどのお客様フロアにある設備の消毒',
	'病室のトラスト：ドアノブ、清算機、待合室などの患者様が使用する設備の消毒': '病室向け：ドアノブ、清算機、待合室などの患者様が使用する設備の消毒',
	'教室のトラスト：ドアノブ、机、水道の蛇口などの学校関係者が使用する設備の消毒': '教室向け：ドアノブ、机、水道の蛇口などの、生徒、学生などが使用する設備の消毒',
	'おみせのトラスト：お客様の退席後、テーブル上の消毒もしくはテーブルクロスの交換を実施': '店舗向け：お客様の退席後、テーブル上の消毒もしくはテーブルクロスの交換を実施',
	'病室のトラスト：患者様の退出後、使用した設備の消毒': '病室向け：患者様の退出後、使用した設備の消毒',
	'教室のトラスト：学校関係者が退出後、使用した設備の消毒': '教室向け：生徒、学生などが退出後、使用した設備の消毒',
	'トイレ定期清掃・消毒、消毒液設置を実施': 'トイレ定期清掃・消毒、消毒液設置を実施',
	'認証の取得	': '認証の取得	',
	'自治体等の第三者機関が発行する認証店マークを取得': '感染防止対策に対する自治体等の第三者が発行する認証を取得',
	'部屋一覧': '部屋一覧',
	'部屋追加': '部屋追加',
	'部屋ID': '部屋ID',
	'部屋名': '部屋名',
	'部屋英語名': '部屋英語名',
	
	
	'更新': '更新',
	'店舗/学校/病院情報が更新されました。': '店舗/学校/病院情報が更新されました。',
	'表示ポータルを選択してください': '表示ポータルを選択してください',
	'＆、スペースは入力できません。': '＆、スペースは入力できません。',
	'入力されたURL、もしくは動画IDが正しくありません。': '入力されたURL、もしくは動画IDが正しくありません。',
	
	'店舗の副管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。': '店舗の副管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。',
	'店舗情報更新時にエラーが発生しました': '店舗情報更新時にエラーが発生しました',
	
	
	'指定された店舗が管理対象店舗でないため表示できません。': '指定された店舗が管理対象店舗でないため表示できません。',
	'店舗情報詳細取得時にエラーが発生しました': '店舗情報詳細取得時にエラーが発生しました',
	
	'画像一覧取得時にエラーが発生しました': '画像一覧取得時にエラーが発生しました',
	
	'画像のサイズが制限値を超えています。': '画像のサイズが制限値を超えています。',
	'画像のファイルサイズが制限値を超えています。': '画像のファイルサイズが制限値を超えています。',
	'画像アップロード時にエラーが発生しました': '画像アップロード時にエラーが発生しました',
	'画像アップロードに失敗しました。': '画像アップロードに失敗しました。',
	'{FileName}を削除予約します。更新後、この画像は削除されます。': '{FileName}を削除予約します。更新後、この画像は削除されます。',
	'画像更新(削除予定)時にエラーが発生しました': '画像更新(削除予定)時にエラーが発生しました',
	'{roomName}（{xx}行目）を削除します。よろしいですか？': '{roomName}（{xx}行目）を削除します。よろしいですか？',
	'部屋（{xx}行目）を削除します。よろしいですか？': '部屋（{xx}行目）を削除します。よろしいですか？',
	'削除対象のデータがありません': '削除対象のデータがありません',
	'部屋削除時にエラーが発生しました': '部屋削除時にエラーが発生しました',
	//'{管理者メールアドレス}を削除します。よろしいですか？': '{管理者メールアドレス}を削除します。よろしいですか？',
	'管理者（{xx}行目）を削除します。よろしいですか？': '管理者（{xx}行目）を削除します。よろしいですか？',
	'{phoneNumber}を削除します。よろしいですか？': '{phoneNumber}を削除します。よろしいですか？',
	'アラート通知先電話番号（{xx}行目）を削除します。よろしいですか？': 'アラート通知先電話番号（{xx}行目）を削除します。よろしいですか？',
	'アンケート画面作成': 'アンケート画面作成',
	
	'質問1': '質問1',
	'質問2': '質問2',
	'質問3': '質問3',
	'回答1': '回答1',
	'回答2': '回答2',
	'回答3': '回答3',
	'" は入力できません。': '" は入力できません。',
	'256文字以内で質問文を入力してください': '256文字以内で質問文を入力してください',
	'回答形式を選択してください': '回答形式を選択してください',
	'Yes/No(ラジオボックス)': 'Yes/No(ラジオボックス)',
	'Yes/No/その他(ラジオボックス)': 'Yes/No/その他(ラジオボックス)',
	'1/2/3/4/5(ラジオボックス)': '1/2/3/4/5(ラジオボックス)',
	'自由記述(テキスト)': '自由記述(テキスト)',
	'店舗の管理者/副管理者に登録されているユーザに「店舗レポート」のメールを発行します。': '店舗の管理者/副管理者に登録されているユーザに「店舗レポート」のメールを発行します。',
	'レポートダウンロード': 'レポートダウンロード',
	'年/月を指定して、過去の「店舗レポート」をダウンロードします。': '年/月を指定して、過去の「店舗レポート」をダウンロードします。',
	//  お知らせ管理.一覧
	
	'店舗/学校/病院情報': '店舗/学校/病院情報',
	'公開／非公開': '公開／非公開',
	'公開中': '公開中',
	'非公開': '非公開',
	
	
	
	
	
	
	'一覧に戻る': '一覧に戻る',
	
	'お知らせID': 'お知らせID',
	'公開日': '公開日',
	'タイトル': 'タイトル',
	'更新日': '更新日',
	
	
	'お知らせID={xx} を削除します。よろしいですか？': 'お知らせID={xx} を削除します。よろしいですか？',
	'お知らせ情報が削除されました。': 'お知らせ情報が削除されました。',
	
	'指定された店舗が管理対象店舗でないため検索・表示できません。': '指定された店舗が管理対象店舗でないため検索・表示できません。',
	'お知らせ情報取得時にエラーが発生しました': 'お知らせ情報取得時にエラーが発生しました',
	
	'削除対象のお知らせ情報が存在しませんでした。': '削除対象のお知らせ情報が存在しませんでした。',
	'お知らせ情報削除時にエラーが発生しました': 'お知らせ情報削除時にエラーが発生しました',
	//  お知らせ管理.詳細
	'お知らせ情報の登録': 'お知らせ情報の登録',
	'お知らせ情報の更新': 'お知らせ情報の更新',
	
	'公開開始日': '公開開始日',
	'必須項目です。': '必須項目です。',
	'公開開始日は、2020年1月1日以降を設定してください。': '公開開始日は、2020年1月1日以降を設定してください。',
	
	
	'お知らせ内容': 'お知らせ内容',
	'必須項目です。500文字以内で入力してください。': '必須項目です。500文字以内で入力してください。',
	
	
	
	'お知らせ情報が登録されました。': 'お知らせ情報が登録されました。',
	'お知らせ情報が更新されました。': 'お知らせ情報が更新されました。',
	
	
	'取得できるお知らせ情報がありません': '取得できるお知らせ情報がありません',
	'お知らせ詳細情報取得時にエラーが発生しました': 'お知らせ詳細情報取得時にエラーが発生しました',
	
	'お知らせ情報登録時にエラーが発生しました': 'お知らせ情報登録時にエラーが発生しました',
	
	'更新対象のお知らせ情報が存在しませんでした。': '更新対象のお知らせ情報が存在しませんでした。',
	'お知らせ情報更新時にエラーが発生しました': 'お知らせ情報更新時にエラーが発生しました',
	
	
	
	//  アンケート結果管理.一覧
	
	
	'年：': '年：',
	'月：': '月：',
	'2021年': '2021年',
	'2022年': '2022年',
	'2023年': '2023年',
	'2024年': '2024年',
	'2025年': '2025年',
	'2026年': '2026年',
	'2027年': '2027年',
	'2028年': '2028年',
	'2029年': '2029年',
	'2030年': '2030年',
	'2031年': '2031年',
	'2032年': '2032年',
	'1月': '1月',
	'2月': '2月',
	'3月': '3月',
	'4月': '4月',
	'5月': '5月',
	'6月': '6月',
	'7月': '7月',
	'8月': '8月',
	'9月': '9月',
	'10月': '10月',
	'11月': '11月',
	'12月': '12月',
	
	'一覧再読み込み': '一覧再読み込み',
	
	
	
	
	
	'データ年月': 'データ年月',
	
	
	
	'ダウンロード可能': 'ダウンロード可能',
	'出力中': '出力中',
	'該当データなし': '該当データなし',
	'出力エラー': '出力エラー',
	
	'アンケート回答年月情報取得時にエラーが発生しました。': 'アンケート回答年月情報取得時にエラーが発生しました。',
	'該当データが存在しません。': '該当データが存在しません。',
	
	
	//  店舗/学校/病院確認一覧
	
	'グループを選択してください': 'グループを選択してください',
	'必須項目です。対象のグループを選択してください。': '必須項目です。対象のグループを選択してください。',
	'検索': '検索',
	
	
	
	'下記、店舗/学校/病院記載内容の確認が出来ましたら、確認ボタンをクリックしてください。': '下記、店舗/学校/病院記載内容の確認が出来ましたら、確認ボタンをクリックしてください。',
	
	'確認を行いましたら、以下「確認」ボタンをクリックしてください。': '確認を行いましたら、以下「確認」ボタンをクリックしてください。',
	'確認': '確認',
	'{店舗名}の情報を確認登録します。よろしいですか？': '{shopName}の情報を確認登録します。よろしいですか？',
	'店舗/学校/病院情報が確認登録されました。': '店舗/学校/病院情報が確認登録されました。',
	
	'ユーザ情報が登録されていません。': 'ユーザ情報が登録されていません。',
	'利用権限がありません。': '利用権限がありません。',
	'管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。': '管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。',
	'店舗確認登録時にエラーが発生しました': '店舗確認登録時にエラーが発生しました',
	
	'確認可能な店舗/学校/病院が存在しません。': '確認可能な店舗/学校/病院が存在しません。',
	'店舗確認一覧取得時にエラーが発生しました': '店舗確認一覧取得時にエラーが発生しました',
	
	//  センサー管理
	'店舗編集画面へ': '店舗編集画面へ',
	'対象 店舗/学校/病院 設定': '対象 店舗/学校/病院 設定',
	
	
	'検索候補がありません': '検索候補がありません',
	
	'店舗/学校/病院を選択してください': '店舗/学校/病院を選択してください',
	
	'設定': '設定',
	'センサー登録': 'センサー登録',
	'紐づけ店舗/学校/病院 部屋': '紐づけ店舗/学校/病院 部屋',
	'店舗/学校/病院 部屋を選択してください': '店舗/学校/病院 部屋を選択してください',
	
	'センサーＩＤ': 'センサーＩＤ',
	'必須項目です。センサーＩＤを入力してください。': '必須項目です。センサーＩＤを入力してください。',
	
	'※お手元のセンサーの登録操作をした後、30分以内にセンサーIDを登録してください。': '※お手元のセンサーの登録操作をした後、30分以内にセンサーIDを登録してください。',
	'登録済みセンサー一覧': '登録済みセンサー一覧',
	'詳細確認': '詳細確認',
	
	'店舗/学校/病院 部屋名': '店舗/学校/病院 部屋名',
	'代表センサー': '代表センサー',
	'センサーID': 'センサーID',
	'センサー名': 'センサー名',
	
	'登録解除': '登録解除',
	'センサーID : {sensorId}の登録を解除します。よろしいですか？': 'センサーID : {sensorId}の登録を解除します。よろしいですか？',
	
	
	'データ取得時にエラーが発生しました。': 'データ取得時にエラーが発生しました。',
	
	
	
	
	
	'センサーへの紐づけ登録ができません。センサー端末画面で「Registration」をクリックしてください。': 'センサーへの紐づけ登録ができません。センサー端末画面で「Registration」をクリックしてください。',
	'他の店舗・学校・病院で代表センサーとなっているため、対象センサーの紐づけ解除後に再度登録を実施してください。': '他の店舗・学校・病院で代表センサーとなっているため、対象センサーの紐づけ解除後に再度登録を実施してください。',
	'店舗・学校・病院のセンサーの登録を先に行ってください。': '店舗・学校・病院のセンサーの登録を先に行ってください。',
	'センサー紐づけ登録時にエラーが発生しました': 'センサー紐づけ登録時にエラーが発生しました',
	
	
	'代表センサーを削除することはできません。他のセンサーに代表センサーに変更した後、再度実施してください。': '代表センサーを削除することはできません。他のセンサーに代表センサーに変更した後、再度実施してください。',
	'センサー紐づけ解除時にエラーが発生しました': 'センサー紐づけ解除時にエラーが発生しました',
	//  センサー管理.公開設定
	'センサー設定': 'センサー設定',
	'代表センサーに設定する': '代表センサーに設定する',
	
	'20文字以内で入力してください。': '20文字以内で入力してください。',
	'センサー名（英語）': 'センサー名（英語）',
	
	'公開センサー選択': '公開センサー選択',
	'設定の反映には最大5分間かかります。': '設定の反映には最大5分間かかります。',
	'CO2濃度を公開する': 'CO2濃度を公開する',
	'室温を公開する': '室温を公開する',
	'湿度を公開する': '湿度を公開する',
	'騒音を公開する': '騒音を公開する',
	'混雑指数を公開する': '混雑指数を公開する',
	'暑さ指数を公開する': '暑さ指数を公開する',
	'アラート設定': 'アラート設定',
	'通知先及び通知方法の設定は店舗管理画面で行ってください。': '通知先及び通知方法の設定は店舗管理画面で行ってください。',
	'基準値を15分以上超えた場合、アラート設定先に対して通知が送信されます。': '基準値を15分以上超えた場合、アラート設定先に対して通知が送信されます。',
	'CO2濃度のアラートを通知する': 'CO2濃度のアラートを通知する',
	'通知基準値': '通知基準値',
	'4桁以内の数字で入力してください。': '4桁以内の数字で入力してください。',
	'ppm 以上': 'ppm 以上',
	'室温のアラートを通知する': '室温のアラートを通知する',
	
	'3桁以内の数字で入力してください。': '3桁以内の数字で入力してください。',
	'℃以上': '℃以上',
	'℃以下': '℃以下',
	'湿度のアラートを通知する': '湿度のアラートを通知する',
	
	
	'％以上': '％以上',
	'％以下': '％以下',
	'騒音のアラートを通知する': '騒音のアラートを通知する',
	
	
	'dB以上': 'dB以上',
	'混雑指数のアラートを通知する': '混雑指数のアラートを通知する',
	'暑さ指数のアラートを通知する': '暑さ指数のアラートを通知する',
	
	
	
	
	'センサー情報が更新されました。': 'センサー情報が更新されました。',
	'センサー情報が存在しません': 'センサー情報が存在しません',
	
	'指定されたセンサの紐づけ店舗が管理対象店舗でないため表示できません。': '指定されたセンサの紐づけ店舗が管理対象店舗でないため表示できません。',
	'センサー詳細情報を取得できませんでした': 'センサー詳細情報を取得できませんでした',
	'センサー設定情報取得時にエラーが発生しました': 'センサー設定情報取得時にエラーが発生しました',
	
	'代表センサーは店舗・学校・病院にのみ設定可能です。': '代表センサーは店舗・学校・病院にのみ設定可能です。',
	'代表センサーには公開中のセンサーを選択してください。': '代表センサーには公開中のセンサーを選択してください。',
	'代表センサーを非公開にすることはできません。公開設定を行ってください。': '代表センサーを非公開にすることはできません。公開設定を行ってください。',
	'代表センサーを公開した後、再度実施してください。': '代表センサーを公開した後、再度実施してください。',
	'センサー公開設定にてエラーが発生しました': 'センサー公開設定にてエラーが発生しました',
	'公開センサー選択でチェックしている場合、以下のアラート設定にて、「通知する」にチェックをお勧めします。': '公開センサー選択でチェックしている場合、以下のアラート設定にて、「通知する」にチェックをお勧めします。',
	
	//  センサー管理.詳細確認
	'センサー詳細情報': 'センサー詳細情報',
	
	
	
	
	
	
	
	
	
	
	
	
	'現在の状況': '現在の状況',
	'CO2濃度': 'CO2濃度',
	'室温': '室温',
	'湿度': '湿度',
	'騒音': '騒音',
	'混雑指数': '混雑指数',
	
	'指定されたセンサーの紐づけ店舗が管理対象店舗でないため表示できません。': '指定されたセンサーの紐づけ店舗が管理対象店舗でないため表示できません。',
	'センサー情報が登録されていません。': 'センサー情報が登録されていません。',
	'センサー詳細情報取得時にエラーが発生しました': 'センサー詳細情報取得時にエラーが発生しました',
	'グラフ情報はまだ生成されていません。時間をおいて再度参照してください。': 'グラフ情報はまだ生成されていません。時間をおいて再度参照してください。',
	//  センサーデータダウンロード
	
	
	
	
	
	'（全て）': '（全て）',
	
	
	'データ開始日': 'データ開始日',
	
	'データ終了日': 'データ終了日',
	
	'※最大90日分です。': '※最大90日分です。',
	'クイック入力': 'クイック入力',
	'最新10日分': '最新10日分',
	'最新30日分': '最新30日分',
	'最新90日分': '最新90日分',
	'出力予約': '出力予約',
	'一覧を再読み込み': '一覧を再読み込み',
	'ダウンロード可能期限は1週間です。出力日から1週間後に一覧から削除されます。': 'ダウンロード可能期限は1週間です。出力日から1週間後に一覧から削除されます。',
	'ダウンロード': 'ダウンロード',
	'ステータス': 'ステータス',
	'出力日時': '出力日時',
	
	
	
	
	'履歴削除': '履歴削除',
	'選択された期間が90日を超えています。期間は90日以内で選択してください。': '選択された期間が90日を超えています。期間は90日以内で選択してください。',
	'選択された開始日が終了日よりも未来となっています。': '選択された開始日が終了日よりも未来となっています。',
	'ダウンロードに失敗しました': 'ダウンロードに失敗しました',
	'該当データがありません': '該当データがありません',
	'ダウンロード時にエラーが発生しました': 'ダウンロード時にエラーが発生しました',
	'履歴を削除します。よろしいですか？': '履歴を削除します。よろしいですか？',
	'センサーデータダウンロード時にエラーが発生しました': 'センサーデータダウンロード時にエラーが発生しました',
	'管理情報に基づく店舗一覧取得時にエラーが発生しました': '管理情報に基づく店舗一覧取得時にエラーが発生しました',
	
	'ダウンロード情報取得時にエラーが発生しました': 'ダウンロード情報取得時にエラーが発生しました',
	'ダウンロード情報登録時にエラーが発生しました': 'ダウンロード情報登録時にエラーが発生しました',
	'センサーデータ削除時にエラーが発生しました': 'センサーデータ削除時にエラーが発生しました',
	//  セキュリティ情報管理.一覧
	
	
	
	
	
	
	
	'ユーザー一覧': 'ユーザー一覧',
	
	
	
	
	
	
	
	
	//'条件クリア': '条件クリア', 重複
	
	//  セキュリティ情報管理.詳細
	'セキュリティ情報の更新': 'セキュリティ情報の更新',
	'店舗/学校/病院 セキュリティ設定': '店舗/学校/病院 セキュリティ設定',
	'管理ユーザー(セキュリティ設定にかかわらず参照可能）': '管理ユーザー(セキュリティ設定にかかわらず参照可能）',
	'セキュリティコード': 'セキュリティコード',
	'セキュリティコードは、半角8文字以上12文字以内の文字列で、英大文字・英小文字・数字それぞれを最低1文字ずつ含む必要があります。': 'セキュリティコードは、半角8文字以上12文字以内の文字列で、英大文字・英小文字・数字それぞれを最低1文字ずつ含む必要があります。',
	'・使用できる文字は、半角英字（大文字・小文字）・半角の数字です。': '・使用できる文字は、半角英字（大文字・小文字）・半角の数字です。',
	'・英大文字・英小文字・数字それぞれを最低1文字ずつ含む必要があります。': '・英大文字・英小文字・数字それぞれを最低1文字ずつ含む必要があります。',
	'・長さは、半角8文字以上 半角12文字以下です。': '・長さは、半角8文字以上 半角12文字以下です。',
	'管理ユーザー登録': '管理ユーザー登録',
	'管理ユーザー一括削除': '管理ユーザー一括削除',
	'ユーザー全削除': 'ユーザー全削除',
	'{店舗名}の管理ユーザーのユーザー削除 を行います。よろしいですか？': '{shopName}の管理ユーザーのユーザー削除 を行います。よろしいですか？',
	'{店舗名}の管理者以外のユーザー削除 を行います。よろしいですか？': '{shopName}の管理者以外のユーザー削除 を行います。よろしいですか？',
	'店舗/学校/病院設定': '店舗/学校/病院設定',
	
	'セキュリティ設定': 'セキュリティ設定',
	'フリー公開': 'フリー公開',
	'ユーザー公開': 'ユーザー公開',
	'特定ユーザー公開': '特定ユーザー公開',
	
	'ユーザー登録': 'ユーザー登録',
	'ユーザー一括削除': 'ユーザー一括削除',
	'部屋別セキュリティ一覧': '部屋別セキュリティ一覧',
	
	
	
	
	'店舗/学校/病院の設定がフリー公開の場合のみ、部屋をフリー公開に設定することが可能です。': '店舗/学校/病院の設定がフリー公開の場合のみ、部屋をフリー公開に設定することが可能です。',
	'ユーザー公開の設定がいずれかにある場合には、特定ユーザー公開の設定が必須です。': 'ユーザー公開の設定がいずれかにある場合には、特定ユーザー公開の設定が必須です。',
	'特定ユーザー公開の場合、セキュリティコードは必須です。': '特定ユーザー公開の場合、セキュリティコードは必須です。',
	'特定ユーザー公開以外の場合、セキュリティコードは不要です。': '特定ユーザー公開以外の場合、セキュリティコードは不要です。',
	// '特定ユーザー公開の場合、セキュリティコードは必須です。 対象：{部屋名}': '特定ユーザー公開の場合、セキュリティコードは必須です。 対象：{部屋名}',
	// '特定ユーザー公開以外の場合、セキュリティコードは不要です。 対象：{部屋名}': '特定ユーザー公開以外の場合、セキュリティコードは不要です。 対象：{部屋名}',
	'管理者セキュリティコードは入力必須です。': '管理者セキュリティコードは入力必須です。',
	
	'セキュリティ詳細情報取得時にエラーが発生しました': 'セキュリティ詳細情報取得時にエラーが発生しました',
	'セキュリティ情報更新時にエラーが発生しました': 'セキュリティ情報更新時にエラーが発生しました',
	'{店舗名}のユーザー削除 を行います。よろしいですか？': '{shopName}のユーザー削除 を行います。よろしいですか？',
	'削除が完了しました。': '削除が完了しました。',
	'セキュリティユーザー削除時にエラーが発生しました。': 'セキュリティユーザー削除時にエラーが発生しました。',
	'対象：': '対象：',
	//  
	//  セキュリティ情報管理.ユーザー一覧
	
	
	'メールアドレス': 'メールアドレス',
	
	
	
	'店舗/学校/病院/部屋': '店舗/学校/病院/部屋',
	'管理ユーザー': '管理ユーザー',
	
	'管理対象店舗でないため表示できません。': '管理対象店舗でないため表示できません。',
	'セキュリティユーザー一覧取得時にエラーが発生しました': 'セキュリティユーザー一覧取得時にエラーが発生しました',
	'{メールアドレス} のユーザー削除 を行います。よろしいですか？': '{mailAddress} のユーザー削除 を行います。よろしいですか？',
	
	
	
	//  グラフ埋め込み用HTML出力.一覧
	
	
	'コード表示/プレビュー': 'コード表示/プレビュー',
	
	'出力ID': '出力ID',
	
	'形式': '形式',
	'登録名': '登録名',
	'更新日時': '更新日時',
	
	'埋め込みHTML設定情報一覧取得時にエラーが発生しました': '埋め込みHTML設定情報一覧取得時にエラーが発生しました',
	'{出力ID　登録名} を削除します。よろしいですか？': '{embeddedId}　{registerName} を削除します。よろしいですか？',
	'埋め込みHTML設定情報削除時にエラーが発生しました': '埋め込みHTML設定情報削除時にエラーが発生しました',
	'埋め込み情報が削除されました。': '埋め込み情報が削除されました。',
	//  グラフ埋め込み用HTML出力.コード表示・プレビュー
	'タグ': 'タグ',
	//  グラフ埋め込み用HTML出力.詳細
	
	
	'店舗/学校/病院名を選択してください。': '店舗/学校/病院名を選択してください。',
	
	'表示形式': '表示形式',
	'表示形式を選択してください': '表示形式を選択してください',
	'横幅可変(300px以上）、複数種類センサー、単一場所（端末）': '横幅可変(300px以上）、複数種類センサー、単一場所（端末）',
	'横幅可変(200px～300px）、単一種類センサー、複数場所（端末）': '横幅可変(200px～300px）、単一種類センサー、複数場所（端末）',
	'縦横幅固定(300px×250px)、2種類センサー、単一場所（端末）': '縦横幅固定(300px×250px)、2種類センサー、単一場所（端末）',
	
	
	'グラフ埋め込み情報': 'グラフ埋め込み情報',
	'埋め込みID': '埋め込みID',
	
	
	
	
	
	'公開する': '公開する',
	
	'端末一覧': '端末一覧',
	'公開/非公開': '公開/非公開',
	
	
	
	
	
	
	'選択した「表示形式」の場合、「表示項目」で選択された個数は、指定できません。１～5個選択可能です。': '選択した「表示形式」の場合、「表示項目」で選択された個数は、指定できません。１～6個選択可能です。',
	'選択した「表示形式」の場合、「表示項目」で選択された個数は、指定できません。１個選択可能です。': '選択した「表示形式」の場合、「表示項目」で選択された個数は、指定できません。１個選択可能です。',
	'選択した「表示形式」の場合、「表示項目」で選択された個数は、指定できません。１～２個選択可能です。': '選択した「表示形式」の場合、「表示項目」で選択された個数は、指定できません。１～２個選択可能です。',
	'「端末一覧」にて、非公開または削除されたセンサーIDが選択されています。現在公開されているセンサーIDを選択してください。対象：': '「端末一覧」にて、非公開または削除されたセンサーIDが選択されています。現在公開されているセンサーIDを選択してください。対象：',
	'「端末一覧」が未選択です。センサーIDを選択してください。': '「端末一覧」が未選択です。センサーIDを選択してください。',
	'公開可能なセンサーは最大5個です。公開センサーを再選択してください。': '公開可能なセンサーは最大5個です。公開センサーを再選択してください。',
	'選択した「表示形式」の場合、「端末一覧」で選択された個数は、指定できません。１個のみ選択可能です。': '選択した「表示形式」の場合、「端末一覧」で選択された個数は、指定できません。１個のみ選択可能です。',
	'※ 表示対象のセンサーID（表示順で表示）': '※ 表示対象のセンサーID（表示順で表示）',
	'表示項目': '表示項目',
	
	
	
	
	
	'埋め込み設定 表示カラー': '埋め込み設定 表示カラー',
	'ライト': 'ライト',
	'ダーク': 'ダーク',
	'公開対象のセンサーには、アラート設定をすることを推奨します。': '公開対象のセンサーには、アラート設定をすることを推奨します。',
	'アラート設定：指定した基準値を15分以上超えた場合、アラート通知先に対して通知が送信されます。': 'アラート設定：指定した基準値を15分以上超えた場合、アラート通知先に対して通知が送信されます。',
	'設定方法は、「センサー登録」の公開設定にて、基準値及び通知項目の指定、「店舗/学校/病院情報管理」の「アラート通知設定」にて通知方法、通知先の設定が出来ます。': '設定方法は、「センサー登録」の公開設定にて、基準値及び通知項目の指定、「店舗/学校/病院情報管理」の「アラート通知設定」にて通知方法、通知先の設定が出来ます。',
	
	
	
	
	'HTML出力可能なセンサーIDが見つかりません。センサー登録画面にて公開を行ってください。': 'HTML出力可能なセンサーIDが見つかりません。センサー登録画面にて公開を行ってください。',
	
	'埋め込みHTML設定情報がありません': '埋め込みHTML設定情報がありません',
	'埋め込みHTML設定情報取得時にエラーが発生しました': '埋め込みHTML設定情報取得時にエラーが発生しました',
	
	
	
	'管理者でないため登録できません。': '管理者でないため登録できません。',
	'埋め込みHTML設定情報登録時にエラーが発生しました': '埋め込みHTML設定情報登録時にエラーが発生しました',
	
	
	
	
	'グラフ埋め込み情報が登録されました。': 'グラフ埋め込み情報が登録されました。',
	//  ユーザー情報管理.一覧
	
	
	
	
	'権限': '権限',
	'会社名': '会社名',
	'部署名': '部署名',
	'ユーザーID': 'ユーザーID',
	
	'{ユーザーID} を削除します。よろしいですか？': '{userID} を削除します。よろしいですか？',
	
	'ユーザ情報取得時にエラーが発生しました': 'ユーザ情報取得時にエラーが発生しました',
	
	'施設もしくは店舗の代表管理者となってるため削除できません。': '施設もしくは店舗の代表管理者となってるため削除できません。',
	'ユーザ情報削除時にエラーが発生しました': 'ユーザ情報削除時にエラーが発生しました',
	'ユーザー情報が削除されました。': 'ユーザー情報が削除されました。',
	//  ユーザー情報管理.詳細
	'ユーザー情報の更新': 'ユーザー情報の更新',
	'ユーザー情報の登録': 'ユーザー情報の登録',
	
	
	'EMAILアドレスの書式で、256文字以内で入力してください。': 'EMAILアドレスの書式で、256文字以内で入力してください。',
	
	'必須項目です。対象の権限を選択してください。': '必須項目です。対象の権限を選択してください。',
	
	
	
	
	
	'ユーザー情報が登録されました。': 'ユーザー情報が登録されました。',
	'ユーザー情報が更新されました。': 'ユーザー情報が更新されました。',
	
	'ユーザー詳細取得時にエラーが発生しました': 'ユーザー詳細取得時にエラーが発生しました',
	'すでに登録されているメールアドレスのため登録できません': 'すでに登録されているメールアドレスのため登録できません',
	'ユーザ情報登録時にエラーが発生しました': 'ユーザ情報登録時にエラーが発生しました',
	'すでに登録されているメールアドレスのため更新できません': 'すでに登録されているメールアドレスのため更新できません',
	'ユーザ情報更新時にエラーが発生しました': 'ユーザ情報更新時にエラーが発生しました',
	//  メニュー
	'ユーザ権限取得時にエラーが発生しました': 'ユーザ権限取得時にエラーが発生しました',
	//  マニュアル/FAQ
	'マニュアル': 'マニュアル',
	'操作マニュアル': '画面項目説明書',
	'簡易マニュアル': '操作手順書',
	'FAQ': 'FAQ',
	//  利用規約
	//  
	//  
	//  ログイン
	'ログイン': 'ログイン',
	'登録済みのメールアドレスとパスワードを入力し、ログインしてください。': '登録済みのメールアドレスとパスワードを入力し、ログインしてください。',
	
	'パスワード': 'パスワード',
	
	'パスワードを忘れた方はこちら': 'パスワードを忘れた方はこちら',
	
	'初めて利用する方': '初めて利用する方',
	'おみせのトラストを初めて利用する方は、ユーザー登録が必要です。': 'T*Platsを初めて利用する方は、ユーザー登録が必要です。',
	'以下のユーザー登録ボタンを押して、メールアドレスとパスワードを設定してください。': '以下のユーザー登録ボタンを押して、メールアドレスとパスワードを設定してください。',
	
	'メールアドレスまたは、パスワードを確認してください。': 'メールアドレスまたは、パスワードを確認してください。',
	//  ユーザー登録.利用規約
	'本HPのご利用前に、以下利用規約（アンカーリンク）をご確認ください。': '本HPのご利用前に、以下利用規約（<a href="#termOfService">こちら</a>）をご確認ください。',
	'ご利用開始した時点で利用規約に同意したものとみなします。': 'ご利用開始した時点で利用規約に同意したものとみなします。',
	'本HP「おみせのトラスト」は、お店のトラスト情報（信頼性情報）を見える化する実証実験です。': '本HP「T*Plats」は、お店のトラスト情報（信頼性情報）を見える化します。',
	'ここでいうトラスト情報とは、以下にあるコロナ対策を実施してるかを証明し、 確認できるようにすることを目的としています。': 'ここでいうトラスト情報とは、以下にあるコロナ対策を実施してるかを証明し、 確認できるようにすることを目的としています。',
	'（※本実証実験は、内閣府が進める戦略的イノベーション想像プログラム（SIP)': '',
	'「IoT社会に対応したサイバー・フィジカル・セキュリティ」': '',
	'（管理法人_国立研究開発法人_新エネルギー_産業技術総合開発機構）によって実施されています。）': '',
	'利用規約に同意し、ユーザー登録へ進む。': '利用規約に同意し、ユーザー登録へ進む。',
	
	'原文を参照': '原文を参照',
	//  ユーザー登録
	
	'登録するメールアドレスとパスワードを入力してください。': '登録するメールアドレスとパスワードを入力してください。',
	'ユーザー登録用の検証コードが送信されます。': 'ユーザー登録用の検証コードが送信されます。',
	'メールが受信できない場合は、「@trust-shop.hitachi.co.jp」のドメインを受信する設定にご変更ください。': 'メールが受信できない場合は、「@tplats.hitachi.co.jp」のドメインを受信する設定にご変更ください。',
	'パスワードは、大文字、小文字、数字を含む、8桁以上の値を設定してください。': 'パスワードは、大文字、小文字、数字を含む、8桁以上の値を設定してください。',
	
	
	'パスワード（確認）': 'パスワード（確認）',
	'検証コードを送信する': '検証コードを送信する',
	'ログイン画面に戻る': 'ログイン画面に戻る',
	'再ログインしてください。': '再ログインしてください。',
	'メールアドレスが未登録です。管理者に問い合わせてください。': 'メールアドレスが未登録です。管理者に問い合わせてください。',
	'すでにユーザーが登録されています。検証コードの入力が完了していない場合は、ログイン画面からログインし、ユーザー登録を完了してください。パスワードを忘れた場合は、ログイン画面からパスワード変更を行ってください。': 'すでにユーザーが登録されています。検証コードの入力が完了していない場合は、ログイン画面からログインし、ユーザー登録を完了してください。パスワードを忘れた場合は、ログイン画面からパスワード変更を行ってください。',
	
	'パスワードと、パスワード（確認）が一致しません。': 'パスワードと、パスワード（確認）が一致しません。',
	//  ユーザー登録完了
	'ユーザー登録の完了': 'ユーザー登録の完了',
	'{UserName}に検証用コードを送信しました。': '{UserName}に検証用コードを送信しました。',
	'検証用コードを入力し、ユーザー登録を完了してください。': '検証用コードを入力し、ユーザー登録を完了してください。',
	'検証コード': '検証コード',
	'ユーザー登録を完了する': 'ユーザー登録を完了する',
	'検証コードを再送する': '検証コードを再送する',
	'検証コードを確認してください。': '検証コードを確認してください。',
	//  パスワードリセット
	'パスワードリセット': 'パスワードリセット',
	'登録済みのメールアドレスを入力してください。': '登録済みのメールアドレスを入力してください。',
	'パスワード変更用の検証コードが送信されます。': 'パスワード変更用の検証コードが送信されます。',
	
	
	
	//  パスワード更新
	'パスワード更新': 'パスワード更新',
	
	
	
	
	'パスワード変更': 'パスワード変更',
	
	
	'新しいパスワードと、新しいパスワード（確認）が一致しません。': '新しいパスワードと、新しいパスワード（確認）が一致しません。',
	//  センサーデデータダウンロード画面(追加分)
	'詳細条件': '詳細条件',
	'データラベル': 'データラベル',
	'英語': '英語',
	'日本語': '日本語',
	'出力項目': '出力項目',
	'出力するデータの種類': '出力するデータの種類',
	'環境データ': '環境データ',
	'ブルートゥース詳細データ': 'ブルートゥース詳細データ',
	'全選択': '全選択',
	'全解除': '全解除',
	'共通項目：設置場所': '共通項目：設置場所',
	'共通項目：時間': '共通項目：時間',
	'出力データ': '出力データ',
	'データ加工なし': 'データ加工なし',
	'データベースに格納されているデータ（1分毎）を出力します。': 'データベースに格納されているデータ（1分毎）を出力します。',
	'5分平均値': '5分平均値',
	'5分毎の平均値を出力します。': '5分毎の平均値を出力します。',
	'10分平均値': '10分平均値',
	'10分毎の平均値を出力します。': '10分毎の平均値を出力します。',
	'30分平均値': '30分平均値',
	'30分毎の平均値を出力します。': '30分毎の平均値を出力します。',
	'1時間平均値': '1時間平均値',
	'1時間毎の平均値を出力します。': '1時間毎の平均値を出力します。',
	'詳細': '詳細',
	'ダウンロード項目': 'ダウンロード項目',
	//重複
	// 'ダウンロード可能': 'ダウンロード可能',
	// '出力中': '出力中',
	// '該当データなし': '該当データなし',
	// '出力エラー': '出力エラー',
	// '該当データが存在しません。': '該当データが存在しません。',
	//  アラート通知機能メッセージ内容
	'検知日時': '検知日時',
	'施設名': '施設名',
	'店舗名': '店舗名',
	
	'以下の計測項目が指定した基準値を超えています。': '以下の計測項目が指定した基準値を超えています。',
	'CO2': 'CO2',
	
	
	
	
	'計測値': '計測値',
	'指定した基準値': '指定した基準値',
	'ppm以上': 'ppm以上',
	'°C以上': '°C以上',
	'°C以下': '°C以下',
	'%以上': '%以上',
	'%以下': '%以下',
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	'【おみせのトラスト】アラート通知': '【T*Plats】アラート通知',
	
	
	'以下の計測項目が基準値を超えています。': '以下の計測項目が基準値を超えています。',
	
	
	
	
	
	//  センサー管理 センサー設定画面(追加分)
	// '基準値を15分以上超えた場合、アラート設定先に対して通知が送信されます。': '基準値を15分以上超えた場合、アラート設定先に対して通知が送信されます。',
	//  セキュリティ情報管理 ユーザー登録
	'ユーザ登録用QRコード表示': 'ユーザ登録用QRコード表示',
	'登録用URL': '登録用URL',
	//  公開機能
	'場所を探す': '場所を探す',
	'よくある質問': 'よくある質問',
	'アンケート': 'アンケート',
	'お客様満足度アンケート': 'お客様満足度アンケート',
	'いつもご利用いただき誠にありがとうございます。よりお客様にご満足いただけるサービスが提供できるよる、アンケートを行っております。ぜひご意見をお聞かせください': 'いつもご利用いただき誠にありがとうございます。よりお客様にご満足いただけるサービスが提供できるよる、アンケートを行っております。ぜひご意見をお聞かせください',
	'※　本アンケートは、各店舗の顧客満足度把握が目的です。個人情報の取得は行いませんので、ご入力はお控え下さい。各店舗への誹謗中傷はお控え下さい。': '※　本アンケートは、各店舗の顧客満足度把握が目的です。個人情報の取得は行いませんので、ご入力はお控え下さい。各店舗への誹謗中傷はお控え下さい。',
	'アンケートを送信する': 'アンケートを送信する',
	'はい': 'はい',
	'いいえ': 'いいえ',
	'その他': 'その他',
	'満足': '満足',
	'やや満足': 'やや満足',
	'どちらともいえない': 'どちらともいえない',
	'やや不満': 'やや不満',
	'不満': '不満',
	'表示モード': '表示モード',
	'標準': '標準',
	'サイネージモード（タブレット）': 'サイネージモード（タブレット）',
	'サイネージモード（スマホ）': 'サイネージモード（スマホ）',

	// 追加メニュー分
	'店舗/学校/病院情報管理 / お知らせ管理': '店舗/学校/病院情報管理 / お知らせ管理',
	'店舗/学校/病院情報管理 / アンケート結果': '店舗/学校/病院情報管理 / アンケート結果',

	// センサーグラフ
	// CO2
	'換気が必要': '換気が必要',
  'やや換気が必要': 'やや換気が必要',
  'よい.CO2濃度': 'よい',
	// 室温
  '高い.室温': '高い',
  'よい.室温': 'よい',
  '低い.室温': '低い',
	// 湿度
  '高い.湿度': '高い',
  'よい.湿度': 'よい',
  '乾燥している': '乾燥している',
	// 騒音
  '非常にうるさい': '騒がしい',
  'うるさい': 'にぎやか',
  'ふつう': 'ふつう',
  '静か': '静か',
	// 混雑指数
	'混雑': '混雑',
  'やや混雑': 'やや混雑',
  'よい.混雑指数': 'よい',
	// 暑さ指数
	'暑さ指数': '暑さ指数',
  '危険.暑さ指数': '危険',
  '厳重警戒.暑さ指数': '厳重警戒',
  '警戒.暑さ指数': '警戒',
  '注意.暑さ指数': '注意',
  'ほぼ安全.暑さ指数': 'ほぼ安全',

	// 追加
	'※入力された住所を、サイト内でGoogleMap表示しますので、入力後にプレビューボタンで誤りが無いかご確認ください。': '※入力された住所を、サイト内でGoogleMap表示しますので、入力後にプレビューボタンで誤りが無いかご確認ください。',
	'セキュリティ情報が更新されました。': 'セキュリティ情報が更新されました。',

  // 規約
  'SLA': 'SLA',
  'サービス仕様書': 'サービス仕様書',

	// リセラー情報管理
	'選択中のリセラー': '選択中のリセラー',
	'リセラーID': 'リセラーID',
	'リセラー名': 'リセラー名',
	'確定': '確定',
	'切替': '切替',
	'{リセラーID} を削除します。よろしいですか？': '{resellerId} を削除します。よろしいですか？',
	'親リセラーID': '親リセラーID',
	'親リセラー名': '親リセラー名',
	'リセラー管理会社名': 'リセラー管理会社名',
	'管理者のメールアドレス': '管理者のメールアドレス',
	'副管理者のメールアドレス': '副管理者のメールアドレス',
	'リセラー情報の登録': 'リセラー情報の登録',
	'リセラー情報の更新': 'リセラー情報の更新',
	'リセラー情報が登録されました。': 'リセラー情報が登録されました。',
	'リセラー情報が更新されました。': 'リセラー情報が更新されました。',
	'リセラー情報が削除されました。': 'リセラー情報が削除されました。',

	// リセラー選択
	'リセラー選択': 'リセラー選択',
	'上位／下位': '上位／下位',
	'リセラーを切り替える場合は、「リセラー選択」ボタンで選択し、「確定」ボタンを押してください。': 'リセラーを切り替える場合は、「リセラー選択」ボタンで選択し、「確定」ボタンを押してください。',

	// 共通リセラーチェック処理
	'ユーザー権限取得時にエラーが発生しました。': 'ユーザー権限取得時にエラーが発生しました。',
	'ユーザーのリセラー権限取得時にエラーが発生しました。': 'ユーザーのリセラー権限取得時にエラーが発生しました。',
	'参照・選択可能なリセラー情報がありません。': '参照・選択可能なリセラー情報がありません。',

}
